import { IconRender, InheritProps } from '../IconRender';

export function NoneIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="2" y="2" width="76" height="76" rx="11" fill="#343434" stroke={color} strokeWidth="3" />
          <circle cx="40" cy="40" r="17" fill="#343434" stroke="#D9D9D9" strokeWidth="5" />
          <line x1="54" y1="29" x2="29" y2="50" stroke="#D9D9D9" strokeWidth="5" />
        </>
      )}
    />
  );
}
